module.exports = __webpack_public_path__ + "static/media/Seahorse.f1ea4dcb.png";